(function () {
    'use strict';

    angular.module('PWAPoCApp').directive('routeStopFilter', routeStopFilter);

    routeStopFilter.$inject = [];

    function routeStopFilter() {
        var directive = {
            controller: ['$rootScope', '$scope', 'routeStopsService', 'appSettings', 'translateService', routeStopFilter],
            replace: true,
            restrict: 'E',
            scope: {},
            templateUrl: 'app/shared/directives/route-stop-filter.html'
        };

        return directive;

        function routeStopFilter($rootScope, $scope, routeStopsService, appSettings, translateService) {
            $scope.filter = { option: null, value: '' };
            $scope.filterOptions = [];
            $scope.forceFiltering = false;
            $scope.translate = translateService.translate;

            $scope.filterOptionClicked = filterOptionClicked;
            $scope.filterChanged = filterChanged;
            $scope.clearFilter = clearFilter;
            $scope.filterNoPosition = filterNoPosition;
            $scope.filterToPositionlessRouteStops = false;
            $scope.isUncompletedPositionLessRouteStop = false;

            $scope.$on('changeFilter', changeFilter);

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (fromState.name === 'main.routeStops' || fromState.name === 'main.completedRouteStops') {
                    clearFilterValue();
                }
            });

            $scope.isActive = isActive;

            initializeFiltering();

            function initializeFiltering() {
                //configure selective filter usage for views
                $scope.filterOptions = _.reject(appSettings.filterOptions.slice(),
                    function (o) {
                        return _.indexOf(o.supportedViews, $rootScope.userType) === -1;
                    });

                var filterBy = routeStopsService.getFilterBy();
                $scope.filter.option = _.find($scope.filterOptions, { name: filterBy });
            }

            function changeFilter(evt, filterName) {
                var option = _.find($scope.filterOptions, { name: filterName });
                if (option) {
                    filterOptionClicked(option);
                }
            }

            function filterOptionClicked(filterOption) {
                if (!isActive(filterOption)) {
                    $scope.filter.value = '';
                }

                if (filterOption.presetValue) {
                    $scope.filter.value = filterOption.presetValue;
                }

                $scope.filter.option = filterOption;
                routeStopsService.saveFilterBy(filterOption.name);

                filterChanged();
            }

            function filterChanged() {
                if ($scope.filter && $scope.filter.option) {
                    if ($scope.forceFiltering || ($scope.filter.value && $scope.filter.value.length >= $scope.filter.option.applyMinLength)) {
                        $scope.forceFiltering = $scope.filter.value.length > 0;
                        $rootScope.$broadcast('routeStopsFilterChanged', $scope.filter);
                    }
                }
            }

            function clearFilter() {
                resetFilter();
                $scope.filter.value = '';
                filterChanged();
            }

            function clearFilterValue() {
                $scope.filter.value = '';
                filterChanged();
            }

            function resetFilter() {
                changeFilter(null, 'description');
            }

            function isActive(filterOption) {
                if ($scope.filter && $scope.filter.option) {
                    return $scope.filter.option.id === filterOption.id;
                }
                return false;
            }

            function filterNoPosition() {
                $scope.filterToPositionlessRouteStops = !$scope.filterToPositionlessRouteStops;
                $rootScope.$broadcast('filterNoPosition');
            }

            $scope.$on('setNotPositionVisibility', (event, visibility) => {
                console.log('isUncompletedPositionLessRouteStop', visibility)
                $scope.isUncompletedPositionLessRouteStop = visibility;
            })

        }
    }
})();
